import { createContext, useEffect, useState } from 'react';
import { getUserInfo } from '../api/authAPI';

const AuthContext = createContext({
	token: '',
	userData: {},
	isLoggedIn: false,
	login: (token, userData) => {},
	logout: () => {}
});

export const getStoredTokenData = () => {
	const storedToken = localStorage.getItem('token');

	return {
		token: storedToken
	};
};
export const getStoredRoleData = () => {
	const storedRole = localStorage.getItem('role');

	return {
		role: storedRole
	};
};

export const AuthContextProvider = (props) => {
	const tokenData = getStoredTokenData();

	let initialToken;
	if (tokenData) {
		initialToken = tokenData.token;
	}

	const [token, setToken] = useState(initialToken);
	const [userData, setUserData] = useState({});
	const userIsLoggedIn = !!token;

	//TODO replace useEffect with useQuery

	useEffect(() => {
		fetchUserData();
	}, []);

	const logoutHandler = () => {
		setToken(null);
		setUserData('');
		localStorage.removeItem('token');
		localStorage.removeItem('role');
	};

	const loginHandler = (token, userData) => {
		setToken(token);
		setUserData(userData);
		localStorage.setItem('token', token);
		//console.log(userData);
		localStorage.setItem('role', userData.role);
	};

	const fetchUserData = async () => {
		if (userData.role) {
			return;
		}
		const userInfo = await getUserInfo();
		setUserData(userInfo.data.user);
	};

	const contextValue = {
		token: token,
		userData: userData,
		isLoggedIn: userIsLoggedIn,
		login: loginHandler,
		logout: logoutHandler
	};

	return (
		<AuthContext.Provider value={contextValue}>
			{props.children}
		</AuthContext.Provider>
	);
};
export default AuthContext;
